export const toFixed = (value, count = 4) => {
  if (isNaN(value)) return value
  const digitAfterComma = value?.toString()?.split(".")?.[1]?.length
  const newValue = +value
  if ((newValue % 1 !== 0) && (digitAfterComma > count)) return +newValue?.toFixed(count)
  return newValue
}